module.exports = __webpack_public_path__ + "mf-3.4293db8.png";